import { render, staticRenderFns } from "./EndDateRequest.vue?vue&type=template&id=b31b99c2"
import script from "./EndDateRequest.vue?vue&type=script&lang=ts"
export * from "./EndDateRequest.vue?vue&type=script&lang=ts"
import style0 from "./EndDateRequest.vue?vue&type=style&index=0&id=b31b99c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports